import { Component, OnInit } from '@angular/core';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-loading-peq',
  templateUrl: './loading-peq.component.html',
  styleUrls: ['./loading-peq.component.scss'],
})
export class LoadingPeqComponent implements OnInit {
  public domain: string = AppConfig.settings.domain;
  public customTheme = localStorage.getItem('ThemeImg');

  constructor() {}

  ngOnInit() {}
}
